<template>
	<AgencyProjectMonitoringFormView :read-only="true"/>
</template>

<script>
	import AgencyProjectMonitoringFormView from "../AgencyProjectMonitoringFormView";

	export default {
		name: "AgencyProjectMonitoringReportReadOnlyView",
		components: {AgencyProjectMonitoringFormView}
	};
</script>

<style scoped>

</style>
